// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';

export const useEstimateDealDurationYears = () => {
  const estimate = useContext(EstimateContext);
  return estimate?.deal_duration?.deal_duration_years;
};
